import { render, staticRenderFns } from "./ViewMethodStudyInformation.vue?vue&type=template&id=fd67164c"
import script from "./ViewMethodStudyInformation.vue?vue&type=script&lang=js"
export * from "./ViewMethodStudyInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports